import { render, staticRenderFns } from "./ListProduktDetails.vue?vue&type=template&id=52060d31&"
import script from "./ListProduktDetails.vue?vue&type=script&lang=js&"
export * from "./ListProduktDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ListProduktDetails.vue"
export default component.exports